import { redirect } from 'redux-first-router'
import { put, take, takeEvery, select } from 'redux-saga/effects'
import { startAsyncValidation, stopAsyncValidation } from 'redux-form/immutable'

import appActions from 'views/App/actions'
import { accountSelector } from 'views/App/selectors'
import { NAME as ROUTE_HOME } from 'views/Home/constants'

import { reverse } from 'utilities/routes'

import { NAME } from './constants'
import actions from './actions'

export function* onSubmit({ payload }) {
  yield put(startAsyncValidation(NAME))
  yield put(appActions.login({ ...payload }))
  const error = yield take([
    appActions.loginSuccess.toString(),
    appActions.loginError.toString(),
  ])
  const message = error.payload
  yield put(stopAsyncValidation(NAME, message ? { username: message } : null))
}

export default function*() {
  const account = yield select(accountSelector)
  if (account) {
    yield put(redirect(reverse(ROUTE_HOME)))
  }

  yield takeEvery(actions.submit.toString(), onSubmit)
}



// WEBPACK FOOTER //
// ../source/views/Login/sagas.js